export const defaultSeoData = {
	//TODO Initial setup: Configure this
	is: {
		title: 'Straumur',
		description: 'Einföldum flækjurnar, umbreytum flæðinu',
		image: 'https://beta.straumur.is/api/og',
	},
}
